import React from 'react';
import { TypedMemo } from '../../../common/types';
import { useChartTokens } from '../../theme/useChartTokens';

interface ForecastBadgeProps {
  pctChange: number;
  horizonDays: number;
  /** Fully-formatted i18n label string including the signed percentage and horizon days */
  label: string;
}

const ForecastBadgeComponent: React.FC<ForecastBadgeProps> = ({ pctChange, horizonDays, label }) => {
  const chart = useChartTokens();

  const isPositive = pctChange > 0;
  const isNegative = pctChange < 0;
  const color = isPositive ? chart.pos : isNegative ? chart.neg : chart.tx2;

  return (
    <div
      className="d-flex align-items-center mb-2"
      style={{ fontSize: '12px', color, fontVariantNumeric: 'tabular-nums' }}
      data-testid="forecast-badge"
      data-horizon-days={horizonDays}
    >
      <span>{label}</span>
    </div>
  );
};

export const ForecastBadge = TypedMemo(ForecastBadgeComponent);
